import { apiCall, secondaryApi } from "./ApiUtils";
 
export const INSIGHT_PREVIEW="preview"
export const INSIGHT_PENDING="pending"
export const INSIGHT_STUCK="stuck"
export const INSIGHT_RESOLVED="resolved"
export const INSIGHT_DISMISSED="dismissed"

export const MANUAL_INSIGHTS = [
    {title: "Missing Goal Funnels", icon: "/images/alert-icons/goal-completions.png"},
    {title: "Email Instances", icon: "/images/alert-icons/mailto-icon.png"},
    {title: "Bad Channel Tags", icon: "/images/alert-icons/sessions-m.png"},
    {title: "Brand Referral Missing", icon: "/images/alert-icons/brand-referrals.png"},
    {title: "E-Commerce Tracking", icon: "/images/alert-icons/ecom-cart.png"},
    {title: "Coaching Insight", icon: "/images/alert-icons/orange-gear.png"}
]

export const getRecommendations = async(siteId, yyyyMM) => apiCall(`recommendations/${siteId}/${yyyyMM}`, {
    method: 'GET'
}, null, secondaryApi)

export const getRecommendationsForInitialSetup = async(siteId) => apiCall(`recommendations/${siteId}?isManual=1&quickStatsSetup=1`, {
    method: 'GET'
}, null, secondaryApi)

export const updateRecommendation = async(siteId, yyyyMM, recommendation, quickStatsSetup) => apiCall(`recommendations/${siteId}/${yyyyMM}`, {
    method: 'PUT',
    body: {
        recommendations: recommendation.items,
        quickStatsSetup
    }
}, null, secondaryApi)

export const getRecommendationDefinitions = async() => apiCall(`recommendations`, {
    method: 'GET'
}, null, secondaryApi)